import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api, { ApiInputs, ApiResponses } from 'lib/trpcClient';
import { useState } from 'react';
import { downloadFileFromTrpc } from 'further-ui/utils';

const useCapitalActionNoticePdf = () => {
  const [inFlightInvestorPdfDownloads, setInFlightInvestorPdfDownloads] =
    useState<Set<string>>(new Set());
  const { mutateAsync: downloadPdf } =
    api.capitalActionNotice.downloadPdf.useMutation(
      useHandleTrpcMutation<
        ApiResponses['capitalActionNotice']['downloadPdf'],
        ApiInputs['capitalActionNotice']['downloadPdf']
      >()({
        invalidations: [],
        onMutate: ({ investorId, capitalActionId }) => {
          setInFlightInvestorPdfDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.add(`${investorId}-${capitalActionId}`);
            return newSet;
          });
        },
        onSuccess: ({ file, filename, mimeType }) => {
          downloadFileFromTrpc({
            content: file,
            name: filename,
            mimeType,
          });
        },
        onSettled: (_, __, input) => {
          setInFlightInvestorPdfDownloads((prev) => {
            const newSet = new Set(prev);
            newSet.delete(`${input.investorId}-${input.capitalActionId}`);
            return newSet;
          });
        },
      }),
    );

  const isDownloading = (investorId: string, capitalActionId: string) => {
    return inFlightInvestorPdfDownloads.has(`${investorId}-${capitalActionId}`);
  };

  return {
    downloadPdf,
    isDownloading,
  };
};

export default useCapitalActionNoticePdf;
